import { PropsWithChildren } from "react";
import { useScreenSizeClass } from "@/utils/media-query";

export const Root: React.FC<PropsWithChildren> = ({ children }) => {
    const screenSizeClass = useScreenSizeClass();
    return <div className={`app h-auto ${screenSizeClass}`}>{children}</div>;
};
